import { useReadQuery } from '@apollo/client';
import { FC, ReactNode, Suspense } from 'react';
import { UnreadNotificationsQueryQuery } from '@/__generated__/graphql.ts';
import { NavLink } from '@/routes-utils/navigation.tsx';
import { useAppLoader, useAuthenticatedAppLoader } from '../../../loader.ts';
import * as menuActionStyles from './menu-action.css.ts';
import {
  menuItemBadge,
  menuItemLink,
  menuItemText,
} from './menu-action.css.ts';

const NotificationBadge = ({
  unreadNotificationsQueryRef,
}: {
  unreadNotificationsQueryRef: ReturnType<
    typeof useAuthenticatedAppLoader
  >['unreadNotificationsQueryRef'];
}) => {
  const {
    data: {
      notifications: { items: notificationItems },
    },
  } = useReadQuery<UnreadNotificationsQueryQuery>(unreadNotificationsQueryRef);
  const notificationsCount =
    notificationItems.length !== 0
      ? notificationItems.length < 10
        ? String(notificationItems.length)
        : '9+'
      : undefined;

  return notificationsCount ? (
    <span data-testid={'menu-notifications-badge'} className={menuItemBadge}>
      {notificationsCount}
    </span>
  ) : null;
};

export const NotificationsMenuAction: FC<{
  icon: ReactNode;
  label: string;
  to: string;
}> = ({ icon, label, to }) => {
  const data = useAppLoader();

  return (
    <NavLink to={to} className={menuItemLink} prefetch="render">
      <div className={menuActionStyles.iconContainer}>
        {icon}

        {data.authenticated ? (
          <Suspense fallback={null}>
            <NotificationBadge
              unreadNotificationsQueryRef={data.unreadNotificationsQueryRef}
            />
          </Suspense>
        ) : null}
      </div>
      <span className={menuItemText}>{label}</span>
    </NavLink>
  );
};
